export default {
  computed: {
    canOpenCameraRoll() {
      return (
        typeof navigator !== 'undefined' &&
        typeof navigator.camera !== 'undefined'
      )
    },
  },
  methods: {
    openCameraRoll() {
      return new Promise((resolve, reject) => {
        navigator.camera.getPicture(resolve, reject, {
          quality: 50, // 0 - 100
          correctOrientation: true,
          mediaType: window.Camera.MediaType.VIDEO, // PICTURE, VIDEO, ALLMEDIA
          sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
          destinationType: window.Camera.DestinationType.DATA_URL, // NATIVE_URI, FILE_URI, DATA_URL
        })
      })
    },
  },
}
